module.exports = __webpack_public_path__ + "static/media/tracey-6.004156d1.wav";